import React from 'react';
import {View} from 'react-native';
import {isEmpty, noop} from 'lodash';

import Button from '/component/base/Button';
import Text from '/component/base/Text';

import {styles} from './Alert.style';

interface AlertProps {
  alignButtonsAsColumn: boolean;
  description: string;
  title: string;
  leftButtonText: string;
  leftButtonOnPress: () => void;
  rightButtonOnPress: () => void;
  rightButtonText: string;
}

const Alert = ({
  alignButtonsAsColumn = false,
  description = '',
  title = '',
  leftButtonText = '',
  leftButtonOnPress = noop,
  rightButtonOnPress = noop,
  rightButtonText = '',
}: AlertProps) => {
  const buttonContainerStyles = [styles.buttonsContainer];
  const primaryButtonStyles = {};
  if (alignButtonsAsColumn) {
    // @ts-expect-error TS(2345): Argument of type '{ flexDirection: "column"; }' is... Remove this comment to see the full error message
    buttonContainerStyles.push(styles.buttonsContainerColumn);
    // @ts-expect-error TS(2339): Property 'base' does not exist on type '{}'.
    primaryButtonStyles.base = styles.primaryButtonColumn;
  }
  return (
    <View style={styles.container}>
      <Text variant="heading" style={styles.title}>
        {title}
      </Text>
      {!isEmpty(description) && (
        <Text variant="body" style={styles.description}>
          {description}
        </Text>
      )}
      <View style={buttonContainerStyles}>
        <Button
          type="primary"
          onPress={leftButtonOnPress}
          style={primaryButtonStyles}>
          {leftButtonText}
        </Button>
        {rightButtonOnPress ? (
          <>
            <View style={styles.split} />
            <Button type="secondary" onPress={rightButtonOnPress}>
              {rightButtonText}
            </Button>
          </>
        ) : null}
      </View>
    </View>
  );
};

export default Alert;
